module.exports = __webpack_public_path__ + "img/Icon Container (3).c8ba021a.png";